/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Model_Col_ModelInputs */

const en_mk_model_col_model = /** @type {(inputs: Mk_Model_Col_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model`)
};

const id_mk_model_col_model = /** @type {(inputs: Mk_Model_Col_ModelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model`)
};

/**
* | output |
* | --- |
* | "Model" |
*
* @param {Mk_Model_Col_ModelInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_model_col_model = /** @type {((inputs?: Mk_Model_Col_ModelInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Model_Col_ModelInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_model_col_model(inputs)
	return en_mk_model_col_model(inputs)
});